import { AuthServiceInterface } from './AuthServiceInterface';

const ROOT_CACHE = 'ty_cache';
import * as Rx from 'rx';

export class CacheService {
    static $inject = ['AuthService'];

    constructor(private authService: AuthServiceInterface) {}

    removeCacheOnUserChanged() {
        this.authService.onUserChanged((user: any) => {
            const id = user?.id;
            const lastId = this.fromCache('current_user_id');

            if (id !== lastId) {
                this.clearCache();
            }

            this.toCache('current_user_id', id);
        });
    }

    fromCache(key: string, defaultValue: any = null) {
        const fullKey = `${ROOT_CACHE}.${key}`;
        const cachedValue = localStorage.getItem(fullKey);

        if (!cachedValue) {
            return defaultValue;
        }

        try {
            return JSON.parse(cachedValue);
        } catch (e) {
            return defaultValue;
        }
    }

    toCache(key: string, value: any = null) {
        const fullKey = `${ROOT_CACHE}.${key}`;
        return localStorage.setItem(fullKey, JSON.stringify(value));
    }

    cached$(key: string, observable: Rx.Observable<any>) {
        const value = this.fromCache(key);

        if (value) {
            observable = observable.startWith(value);
        }

        return observable.tap((value) => {
            this.toCache(key, value);
        });
    }

    private clearCache() {
        Object.keys(localStorage).forEach((key) => {
            if (key.startsWith(`${ROOT_CACHE}.`)) {
                console.log(`[cache] removing ${key}`);
                localStorage.removeItem(key);
            }
        });
    }
}

angular.module('tradersyard').service('CacheService', CacheService);
